import { connect } from 'react-redux'
import TopMenu from "./TopMenu.jsx";
import { withRouter } from 'react-router-dom';

import {
    getMenuByUsuario,
    getCategoriasByProducto,
    cerrarSesion,
    setCurrentProgram,
    productoSelected,
    showPopUp,
    productoSelectedSave,
    showPopUpPrograma,
    programSelectionCancel,
    programaSelected,
    programaSelectedSave,
    accesoDirectoPopUpPrograma
} from './Actions';

//Importo actions del componente de control de inactvidad
import { actions as idleActions } from '../TimerInactividad/components/TimerInactividad';

const mapStateToProps = (state) => {
    return {
        menuProductos: state.menuProductos,
        globalState: state.sesion.executionContext,
        loggedIn: state.sesion.loggedIn,
        userId: state.sesion.userId
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getMenuByUsuario: (idUsuario) => {
            dispatch(getMenuByUsuario(idUsuario));
        },
        getCategoriasByProducto: (productId) => {
            dispatch(getCategoriasByProducto(productId));
        },
        cerrarSesion: () => {
            dispatch(cerrarSesion());
        },
        setTimerInactividad: () => {
            dispatch(idleActions.start());
        },
        deleteTimerInactividad: () => {
            dispatch(idleActions.stop());
        },
        setCurrentProgram: (currentProgram) => {
            dispatch(setCurrentProgram(currentProgram));
        },
        productoSelected: (productId) => {
            dispatch(productoSelected(productId));
        },
        productoSelectedSave: (productList, productId) => {
            dispatch(productoSelectedSave(productList, productId));
        },
        showPopUp: () => {
            dispatch(showPopUp());
        },
        showPopUpPrograma: () => {
            dispatch(showPopUpPrograma());
        },
        programSelectionCancel: (productoId, userId, startUpSelected) => {
            dispatch(programSelectionCancel(productoId, userId, startUpSelected));
        },
        programaSelected: (programId) => {
            dispatch(programaSelected(programId));
        },
        programaSelectedSave: (productoId, categoryId, userId, startUpSelected) => {
            dispatch(programaSelectedSave(productoId, categoryId, userId, startUpSelected));
        },
        accesoDirectoPopUpPrograma: (defaultPrograma) => {
            dispatch(accesoDirectoPopUpPrograma(defaultPrograma));
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopMenu));


// WEBPACK FOOTER //
// ./Portico/App/Screens/TopMenu/TopMenuContainer.jsx